import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import OrganizationService from "../../../services/OrderingServices/OrganizationService";
import toast from "react-hot-toast";

const MigrationModal = ({ isOpen, toggle, selectedItem }) => {
  console.log("🚀 ~ MigrationModal ~ selectedItem:", selectedItem);
  const [loading, setLoading] = useState(false);
  const handleMigration = async () => {
    try {
      setLoading(true);
      const response = await OrganizationService.applyMigration(
        selectedItem?.orgCode,
      );
      toast.success(response?.message);
      toggle();
    } catch (error) {
      toast.error(error?.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Database Migration</ModalHeader>
      <ModalBody>
        <p>
          You are about to run a database migration for{" "}
          <strong>{selectedItem?.orgName || "this organization"}</strong>.
        </p>
        <p>
          This process will apply pending schema and data changes to the
          database. Please ensure that:
        </p>
        <ul>
          <li>No critical operations are currently running.</li>
          <li>You have taken a recent database backup.</li>
          <li>All users are informed about potential downtime.</li>
        </ul>
        <p style={{ color: "red", fontWeight: "bold" }}>
          ⚠️ This action cannot be undone.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
        <Button color="success" onClick={handleMigration} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" color="light" />
              Migrating...
            </>
          ) : (
            "Run Migration"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MigrationModal;
